import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchAllTodoTemplate(_, props) {
  let url;
  if (props) {
    const { keyword, todoTemplateId } = props;
    if (keyword) {
      url = `/todos/task-template?filter[title][like]=${keyword}`;
    } else if (todoTemplateId) {
      url = `/todos/task-template/${todoTemplateId}`;
    }
  } else {
    url = "/todos/task-template";
  }
  try {
    const res = await apiAxios.get(url);
    return res.data?.data;
  } catch (e) {
    console.log(e);
  }
}

function useTodoTemplateData(props) {
  const { user: userState } = useContext(LoginStateContext);
  if (props) {
    return useQuery(["todo-template", props], fetchAllTodoTemplate, {
      enabled: userState.isLoggedIn,
    });
  } else {
    return useQuery(["todo-template"], fetchAllTodoTemplate, {
      enabled: userState.isLoggedIn,
    });
  }
}

export default useTodoTemplateData;
